import React from 'react';
import Icon from './Icon';

// Modern page header with optional coral icon chip + action slot.
export function PageHeader({ title, subtitle, icon, actions }) {
  return (
    <div className="page-header">
      <div>
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>{actions}</div>}
    </div>
  );
}

const STATUS_VARIANT = {
  active: 'success', paid: 'success', completed: 'success', approved: 'success', onboarded: 'success', success: 'success',
  pending: 'warning', processing: 'warning', under_review: 'warning', underreview: 'warning', review: 'warning',
  failed: 'danger', rejected: 'danger', inactive: 'danger', danger: 'danger',
  info: 'info', default: 'info'
};

export function StatusBadge({ status, label }) {
  const variant = STATUS_VARIANT[String(status || '').toLowerCase()] || 'info';
  return <span className={`badge badge-${variant}`}>{label || status}</span>;
}

export function StatCard({ title, value, icon, accent, color = 'var(--primary-color)' }) {
  return (
    <div className={`stat-card ${accent ? 'accent' : ''}`}>
      <div className="stat-card-icon" style={!accent ? { background: `rgba(3,123,144,0.12)`, color } : undefined}>
        <Icon name={icon} />
      </div>
      <div className="stat-card-content">
        <div className="stat-card-label">{title}</div>
        <div className="stat-card-value">{value}</div>
      </div>
    </div>
  );
}

export function EmptyState({ icon = 'inbox', title, desc, action }) {
  return (
    <div className="empty-state">
      <div className="es-icon"><Icon name={icon} /></div>
      <div className="es-title">{title}</div>
      {desc && <div className="es-desc">{desc}</div>}
      {action && <div className="es-action">{action}</div>}
    </div>
  );
}

export function Toolbar({ children }) {
  return <div className="toolbar">{children}</div>;
}
